import {Component, inject, OnInit, signal} from '@angular/core';
import {AdminUsersTableComponent} from './admin-users-table/admin-users-table.component';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {lastValueFrom} from 'rxjs';
import {User} from '../../../models/user';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';

@Component({
  selector: 'app-admin-users',
  imports: [
    AdminUsersTableComponent,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './admin-users.component.html',
  styleUrl: './admin-users.component.scss'
})
export class AdminUsersComponent implements OnInit {
  private http = inject(HttpClient);
  private url = environment.backendUrl;

  users = signal<User[]>([]);
  searchValue = '';

  async ngOnInit() {
    const users = await lastValueFrom(this.http.get<User[]>(this.url + '/users/system-users'));
    this.users.set(users);
  }
}
